import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServerUrlService } from 'src/app/services/server-url.service';

interface DialogParams {
  accnum: number
  otimusUrl: string
}

@Component({
  selector: 'app-add-anexo-modal',
  templateUrl: './add-anexo-modal.component.html',
  styleUrls: ['./add-anexo-modal.component.scss']
})
export class AddAnexoModalComponent implements OnInit {

  files: FileList | undefined
  description: string = 'Resultado anterior'
  descriptionInput: string = ''

  constructor(
    private serverUrlService: ServerUrlService,
    public dialogRef: MatDialogRef<AddAnexoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogParams
  ) { }

  ngOnInit() {
  }

  onChangeFileInput(event: Event) {
    const target = event.target as HTMLInputElement
    this.files = target.files
  }

  async sendFiles() {
    const files = this.files

    if (!files) {
      this.dialogRef.close()
      return
    }

    if (this.description.toLowerCase() !== 'outro') {
      this.descriptionInput = this.description
    }

    const req2 = await fetch(`${this.serverUrlService.getUrl()}/integracao/pega-token-otimus`, {
      method: 'POST'
    })
    const nometoken = await req2.json()

    for (let i = 0; i < files.length; i++) {
      const file = files[i]

      try {
        await fetch(`${this.data.otimusUrl}/api/v1/agendamento/${this.data.accnum}/anexos`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            descricao: this.descriptionInput,
            fileBase64: await this.blobToBase64(file),
            tipo: file.type.split('/')[1],
            sistema: nometoken.nome,
            token: nometoken.token
          })
        })
      } catch (err) {
        alert('Algum erro ocorreu enquanto os arquivos eram subidos')
      }
    }

    this.dialogRef.close()
  }

  blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

}
